import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { sessionState } from '@chainlit/react-client';

import { targetSelectState, TargetSelectPayload } from '@/state/project';

export default function TargetSelectListener() {
  const session = useRecoilValue(sessionState);
  const setPayload = useSetRecoilState(targetSelectState);

  useEffect(() => {
    const socket = session?.socket;
    if (!socket) return;
    const handler = (payload: TargetSelectPayload) => {
      setPayload(payload);
    };
    const dismissHandler = () => {
      setPayload(null);
    };
    socket.on('ask_target_selection', handler);
    socket.on('dismiss_target_selection', dismissHandler);
    return () => {
      socket.off('ask_target_selection', handler);
      socket.off('dismiss_target_selection', dismissHandler);
    };
  }, [session?.socket, setPayload]);

  return null;
}
